import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Toolbar from '@mui/material/Toolbar';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Custom Components
import GridContainer from '@/ui/Grid/GridContainer';
import FormContent from '@/components/FormContent';
import useFormController from '@/components/useFormController';

import DraggableDialog from '@/ui/Dialog/DraggableDialog';
import DialogToolbarHeading from '@/ui/Dialog/DialogToolbarHeading';
import DialogToolbarButtonClose from '@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose';
import ToolbarFillContent from '@/ui/Toolbar/ToolbarFillContent';
import DialogActionButtonAdd from '@/ui/Dialog/ActionButtons/DialogActionButtonAdd';

import SnackbarContext from '@/context/SnackbarContext/SnackbarContext';
import DialogContext from '@/context/DialogContext/DialogContext';
import Permissions from '@/lib/permissions';

// Types
import {
  ClosingDetails,
  FormControllerProps,
} from '@/@types/components/formController';


const MapAddViewDialog = (props: any) => {
  const { hideDialog } = useContext(DialogContext);
  const { showNotification } = useContext(SnackbarContext);
  const { t } = useTranslation();
  const { dc, onClose } = props;

  const { record, validation, fields, onFieldChange, doInsert } =
    useFormController(props as FormControllerProps);

  function handleInsert() {
    if (doInsert) {
      doInsert().then((result) => {
        if (result.success) {
          close({ dataChanged: true, action: 'insert' });
        } else if (result.error) {
          const msg = t('error.addRecord') + result.error;
          showNotification(msg, 'error');
        } else if (result.validationPass === false) {
          // do nothing
        }
      });
    }
  }

  const handleClose = () => {
    close({ dataChanged: false, action: 'cancel' });
  };

  const close = (result: ClosingDetails) => {
    if (onClose) {
      onClose(result);
    }

    hideDialog();
  };

  return (
    <DraggableDialog open maxWidth="xs" onClose={handleClose}>
      <DialogTitle>
        <Toolbar variant="dense" disableGutters>
          <DialogToolbarHeading>
            {t('titles.add_map_view')}
          </DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogTitle>
      <DialogContent>
        <GridContainer my={2}>
          <FormContent
            fieldNames={dc.getFormFieldsNames('default')}
            record={record}
            validation={validation}
            fields={fields}
            onFieldChange={onFieldChange}
            mode="insert"
            columns={1}
          />
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <DialogActionButtonAdd
          variant="contained"
          onClick={() => handleInsert()}
          needPermission={[Permissions.Private]}
        />
      </DialogActions>
    </DraggableDialog>
  );
};

export default MapAddViewDialog;
